// Matches Appsmith Manufacturing-Dashboard JSObject laborTracking.formatDuration.
export function formatManufacturingLaborDuration(totalSeconds: number): string {
  if (!totalSeconds || totalSeconds <= 0) {
    return "0:00";
  }
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours > 0) {
    return (
      String(hours) +
      ":" +
      String(minutes).padStart(2, "0") +
      ":" +
      String(seconds).padStart(2, "0")
    );
  }
  return String(minutes) + ":" + String(seconds).padStart(2, "0");
}
